import { css, cx } from "@emotion/css";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

type InputErrorProps = {
  Component?: React.ElementType;
  className?: string;
};

export const InputError: React.FC<InputErrorProps> = ({
  Component = "span",
  className,
  children,
}) => {
  const classes = createErrorStyles(useTheme());
  return (
    <Component className={cx(classes.error, className)}>{children}</Component>
  );
};

const createErrorStyles = ({ typography, palette, spacing }: Theme) => {
  return {
    error: css({
      display: "inline-block",
      lineHeight: "normal",
      color: palette.error.textLight,
      fontSize: typography.fontSize.extraSmall,
      fontWeight: typography.fontWeight.semiBold,
      padding: spacing([0.5, 1]),
    }),
  };
};
